import firebase from 'firebase/app';

export default class CreditsService {
  static watchForCredits(
    currentUser,
    successCallback,
    errorCallback,
  ) {
    if (!currentUser) {
      successCallback([]);
      return () => {};
    }

    const ref = firebase
      .firestore()
      .doc(`credits/${currentUser.uid}`);

    return ref.onSnapshot(
      (snapshot) => {
        if (snapshot.exists) {
          successCallback({
            premium: Boolean(snapshot.get('premium')),
            expiresAt: snapshot.get('expiresAt'),
            credits: Number(
              snapshot.get('purchasedAmount') || 0,
            ),
          });
        } else {
          successCallback({ credits: 0 });
        }
      },
      (error) => {
        errorCallback(error);
      },
    );
  }

  static killWatcher(ref) {
    if (ref) {
      ref();
    }
  }
}
